import { render, staticRenderFns } from "./StartupBatchInfo.vue?vue&type=template&id=996cba24&scoped=true"
import script from "./StartupBatchInfo.vue?vue&type=script&lang=js"
export * from "./StartupBatchInfo.vue?vue&type=script&lang=js"
import style0 from "./StartupBatchInfo.vue?vue&type=style&index=0&id=996cba24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996cba24",
  null
  
)

export default component.exports